/*
var scene = document.getElementById('parallax-scene');
var parallax = new Parallax(scene);
*/


//burger code

//toggles menu

jQuery(".header--burger").click(function(){
  jQuery(".header--burger, .header--menu-mobile").toggleClass("active");
});

//toggles burger animation
jQuery(".hamburger").click(function(){
  jQuery(".hamburger").toggleClass("is-active");
});

$('.slideshow').slick({
	infinite: true,
	dots: true,
	arrows: false,
	autoplay: false,
  });